type CreateUserResponse = {
	data?: unknown;
};

export function extractCreatedUserId(
	response?: CreateUserResponse,
): string | undefined {
	const data = response?.data;

	if (!data || typeof data !== "object") return undefined;

	const { content } = data as Record<string, unknown>;

	if (!content || typeof content !== "object") return undefined;

	const { id } = content as Record<string, unknown>;

	return typeof id === "string" ? id : undefined;
}
